import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ArtikelGruppen } from '../../store/models/artikelgruppen';
import { ArtikelGruppenService } from '../shared/artikelgruppen.service';

class FilterString {
    name: string;
    value: number;
}

@Component({
    selector: 'kkis-app-artikel-gruppe-list',
    templateUrl: './artikel-gruppe-list.component.html',
    styleUrls: ['./artikel-gruppe-list.component.scss']
})
export class ArtikelGruppeListComponent implements OnInit {

    // ArtikelGruppe
    artikelGruppen: ArtikelGruppen.IArtikelGruppeDto[];
    reihenfolge: ArtikelGruppen.IReihenfolgeDto;

    // Paging
    page: number = 1;
    pageSize: number = 10;
    maxItems: number = 0;
    previousPage: any;

    // Dropdown-Einträge Paging
    options: string[];
    selectedOption: string = '10';

    // FormGroups
    filterGroup: FormGroup;
    searchGroup: FormGroup;
    searchTerm: string;

    // Subscription
    private subscriptions: Subscription[] = [];

    // Filter
    filterString: string;

    // Utils
    isLoading: boolean = true;
    isFiltered: boolean = false;

    constructor(
        private fb: FormBuilder,
        private artikelGruppenService: ArtikelGruppenService,
    ) { }

    ngOnInit(): void {
        this.loadSequenceData();
        this.filterForm();
        this.searchForm();
        this.loadPage(this.page);
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.loadData(page);
        }
    }

    // FILTERN
    filterForm() {
        this.filterGroup = this.fb.group({
            status: [''],
            sequence: [''],
            searchTerm: [''],
        });
        
        this.subscriptions.push(
            this.filterGroup.controls.status.valueChanges.subscribe(() => {
                this.filter();
            })
        );

        this.subscriptions.push(
            this.filterGroup.controls.sequence.valueChanges.subscribe(res => {
                this.filter()
            })
        );
    }

    filter() {
        const filterList = [] as FilterString[];
        const status = this.filterGroup.get('status').value;
        const sequence = this.filterGroup.get('sequence').value;

        if (status) {
            let filter = {} as FilterString;
            filter.name = 'status';
            filter.value = status;

            filterList.push(filter);
        }

        if (sequence) {
            let filter = {} as FilterString;
            filter.name = 'sequence';
            filter.value = sequence;

            filterList.push(filter);
        }

        this.filterString = JSON.stringify(filterList);

        if (this.filterString) {
            this.isFiltered = true;
        }

        this.loadData(this.page);
    }

    // SUCHE
    searchForm() {
        this.searchGroup = this.fb.group({
            searchTerm: [''],
        });

        const searchEvent = this.searchGroup.controls.searchTerm.valueChanges
            .pipe(
                debounceTime(150),
                distinctUntilChanged()
            ).subscribe((val) => {
                this.searchTerm = val;
                this.loadData(this.page)
            });
        this.subscriptions.push(searchEvent);
    }

    loadData(page: number) {
        if (!this.isFiltered && this.searchTerm == "") {
            this.artikelGruppenService.getList(page - 1, this.pageSize).subscribe(res => {
                this.artikelGruppen = res.items;
                this.maxItems = res.totalCount;
    
                this.options = ['10', '25', '50', '100'];

                this.isLoading = false;
            });
        } else {
            this.artikelGruppenService.getListFilter(page - 1, this.pageSize, "nummer", "asc", this.filterString, this.searchTerm).subscribe(res => {
                this.artikelGruppen = res.items;
                this.maxItems = res.totalCount;

                this.options = ['10', '25', '50', '100'];

                this.isLoading = false;
            });
        }
    }

    loadSequenceData() {
        if (!this.reihenfolge) {
            this.artikelGruppenService.getListReihenfolge().subscribe(res => {
                this.reihenfolge = res;
            });
        }
    }

    pageSizeChanged(event) {
        this.pageSize = event.value;
        this.loadData(this.page);
    }
}
